// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__0h79f","disabled":"Slider_disabled__0QNxu"};